"use client";

import { useEffect, useState } from "react";

import Image from "next/image";
import Link from "next/link";
import { useSearchParams } from "next/navigation";

import getAllArticles from "shared-lib/data/graphql/getAllArticles";

function getFormattedDateString(date: Date) {
  // account for potential timezone difference
  date = new Date(date.getTime() + date.getTimezoneOffset() * 60000);

  const options: any = {
    month: "long" as "long" | "numeric" | "2-digit" | "short" | "narrow",
    day: "numeric" as "numeric" | "2-digit",
    year: "numeric",
  };

  return date.toLocaleDateString("en-US", options);
}

export default function ArticleList() {
  const params = useSearchParams();
  const [articles, setArticles] = useState<Article[]>([]);

  useEffect(() => {
    async function fetchData() {
      const requestedPage = params.get("page") ?? "1";
      const { items } = await getAllArticles({
        limit: 10,
        pageNumber: parseInt(requestedPage) - 1,
        category: "cooking",
      });
      setArticles(items);
    }
    fetchData();
  }, [params]);

  return (
    <ul className="space-y-8">
      {articles.map((article: any) => (
        <li key={article.title}>
          <Link href={"/article/" + article.slug} className="group my-4">
            <div className="flex w-full max-w-lg flex-col overflow-hidden rounded-lg shadow-md transition-shadow group-hover:shadow-lg">
              <div className="relative h-48 w-full flex-shrink-0">
                <Image
                  src={(article?.primaryImages?.items?.[0] ?? {}).url ?? ""}
                  alt=""
                  className="object-cover"
                  fill
                  unoptimized
                />
              </div>
              <div className="flex flex-col justify-between bg-white p-6 text-left">
                <p className="text-xl font-semibold text-gray-900">
                  {article.title}
                </p>
                <p className="mt-3 text-gray-500">{article.kicker}</p>
                <time
                  className="mt-6 text-sm text-gray-500"
                  dateTime={String(article.sys.publishedAt)}
                >
                  {getFormattedDateString(
                    new Date(article.sys.publishedAt ?? ""),
                  )}
                </time>
              </div>
            </div>
          </Link>
        </li>
      ))}
    </ul>
  );
}
